import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    const url = 'https://home.episurveillancekenya.com/api/login';
    try {
      console.log(`Attempting fetch to: ${url}`);
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
        mode: 'cors',
        credentials: 'include',
      });
      console.log(`Response from ${url}:`, {
        status: response.status,
        ok: response.ok,
        headers: [...response.headers.entries()],
        url: response.url,
      });
      const data = await response.json();
      console.log(`Data from ${url}:`, data);
      if (!response.ok) {
        throw new Error(data.error || `Request failed with status ${response.status}`);
      }
      localStorage.setItem('token', data.token);
      console.log('Token saved:', localStorage.getItem('token'));
      try {
        navigate('/dashboard', { replace: true });
        console.log('Navigation to /dashboard triggered');
      } catch (navError) {
        console.error('Navigation error:', navError);
        setError('Failed to navigate to dashboard');
      }
    } catch (err) {
      console.error(`Fetch error for ${url}:`, {
        message: err.message,
        name: err.name,
        stack: err.stack,
        cause: err.cause || 'No cause provided',
      });
      setError(`Failed to connect to ${url}: ${err.message}`);
    }
  };

  return (
    <div className="container mx-auto p-4 flex items-center justify-center min-h-screen bg-gradient-to-b from-blue-100 to-teal-100">
      <div className="w-full max-w-md p-8 bg-white rounded-xl shadow-lg">
        <h2 className="text-3xl font-bold text-blue-800 mb-6 text-center">Admin Login</h2>
        {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2" htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 mb-2" htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full px-4 py-3 bg-teal-500 text-white rounded-md hover:bg-teal-600 transition-all"
          >
            Log In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;